<template>
  <div class="payment">
    <AmList>
      <template v-for="(paymentTypes, idx) in payments">
        <label
          :key="idx"
          class="label--custtom"
          :for="`am-radio-select-${idx}`"
        >
          <AmListItem>
            <template #append>
              <AmRadio
                :id="`select-${idx}`"
                v-model="paymentTypeSelected"
                data-test="select_payment"
                :class="theme.color"
                :option="paymentTypes.option"
                :name="paymentTypes.option.value"
              />
            </template>
            <template #title>
              {{ paymentTypes.title }}
            </template>
            <template
              v-if="idx === 0"
              #subtitle
            >
              <img
                v-for="flag in cardFlags"
                :key="flag"
                class="payment__flags"
                :src="`/img/card-flags/${flag}.svg`"
                :alt="`${flag}`"
              />
            </template>
          </AmListItem>
        </label>
        <hr
          v-if="!paymentTypeSelected || paymentTypes.option.value != paymentTypeSelected"
          :key="`${paymentTypes.title}-hr`"
          class="payment__divider"
        />

        <div
          v-if="showCard(paymentTypes)"
          :key="paymentTypes.title"
          class="payment__card"
        >
          <AmCreditCard
            ref="creditCard"
            v-model="creditCard"
            :label="$t('steps.payment.card.cardNumber')"
            :selectedCardType="selectedCardType"
            @updateCardType="setSelectedCardType"
          />

          <AmInput
            v-if="cart.is_international && documentInternational.includes(cart.country_code)"
            v-model="payment.document"
            v-mask="cart.country_code == 'AR' ? '##.###.###' : '##.###.##-##'"
            :test-name="'dni'"
            class="input--custom"
            :label="$t('steps.payment.card.cpf')"
            :placeholder="cart.country_code == 'AR' ? '__.___.___' : '__.___.__-__'"
            :validity-state="statusCPFValidate"
            :secondary-label="textCPFValidate"
            type="tel"
            @input="validateDNI(true, cart.country_code)"
          />

          <AmInput
            v-if="!cart.is_international"
            v-model="payment.document"
            v-mask="'###.###.###-##'"
            :test-name="'cpf'"
            class="input--custom"
            :label="$t('steps.payment.card.cpf')"
            placeholder="___.___.___-__"
            :validity-state="statusCPFValidate"
            :secondary-label="textCPFValidate"
            type="tel"
            @input="validateCPF"
          />

          <AmInput
            v-model="creditCard.email"
            :test-name="'email'"
            class="input--custom"
            :label="$t('steps.data.email.label', { textOptional: '' })"
            type="email"
            :placeholder="$t('steps.data.email.placeholder')"
            :validity-state="statusEmailValidate"
            :secondary-label="textEmailValidate"
            @focusout.native="validateEmail"
          />

          <AmPhoneNumber
            v-if="cart.is_international"
            v-model="creditCard.telephone"
            :phoneNumberLabel="$t('steps.data.telephone_shopify.label')"
            :error="statusInternationalTelephoneError"
            :defaultCountryCode="cart.country_code"
            :hint="textTelephoneValidate"
            @update="handleInternacionalPhoneInput"
          />

          <AmInputMask
            v-else
            v-model="creditCard.telephone"
            typeMask="fixed"
            :mask="['(##) #####-####', '(##) ####-####']"
            data-test="telephone"
            class="input--custom input-telephone"
            :label="$t('steps.data.telephone_shopify.label')"
            :placeholder="$t('steps.data.telephone.placeholder')"
            :validity-state="statusTelephoneValidate"
            :secondary-label="textTelephoneValidate"
            type="tel"
            @focusout.native="validateThelephone"
          />

          <AmInput
            v-model="payment.name"
            :test-name="'nome'"
            class="input--custom"
            :label="$t('steps.payment.card.name.label')"
            :placeholder="$t('steps.payment.card.name.placeholder')"
            :validity-state="statusNameValidate"
            :secondary-label="textNameValidate"
            @focusout.native="validateName"
          />
          <div
            v-if="isCreditCard"
            class="position-relative input-container"
          >
            <label class="am-input-label mt-3">
              {{ $t('steps.payment.card.installment.label') }}
            </label>
            <select
              v-model="payment.installments"
              class="select-installments"
            >
              <option
                v-for="installment in installments"
                :key="installment.value"
                :value="installment"
              >
                {{ installment.label }}
              </option>
            </select>
            <AmIconMaterial
              type="round"
              name="expand_more"
              size="12"
            />
          </div>
          <div
            v-if="showRecaptcha()"
            class="recaptcha"
          >
            <div
              v-if="recaptchaErrorShow"
              class="recaptcha-show recaptcha-error"
            >
              <span>Assinale não sou um robô</span>
            </div>
            <div class="recaptcha-show">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="recaptchaKey"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
              />
            </div>
          </div>
          <hr class="payment__divider__shopify" />
        </div>

        <div
          v-if="showBillet(paymentTypes)"
          :key="paymentTypes.title"
          class="payment__boleto"
        >
          <BilletMessage />
          <AmInput
            v-model="payment.document"
            v-mask="'###.###.###-##'"
            :test-name="'cpf'"
            class="input--custom mt-3"
            :label="$t('steps.payment.billet.cpf')"
            placeholder="___.___.___-__"
            :validity-state="statusCPFValidate"
            :secondary-label="textCPFValidate"
            type="tel"
            @input="validateCPF"
          />

          <AmInput
            v-model="creditCard.email"
            :test-name="'email'"
            class="input--custom"
            :label="$t('steps.data.email.label', { textOptional: '' })"
            type="email"
            :placeholder="$t('steps.data.email.placeholder')"
            :validity-state="statusEmailValidate"
            :secondary-label="textEmailValidate"
            @focusout.native="validateEmail"
          />

          <AmInputMask
            v-model="creditCard.telephone"
            typeMask="fixed"
            :mask="['(##) #####-####', '(##) ####-####']"
            data-test="telephone"
            class="input--custom input-telephone"
            :label="$t('steps.data.telephone_shopify.label')"
            :placeholder="$t('steps.data.telephone.placeholder')"
            :validity-state="statusTelephoneValidate"
            :secondary-label="textTelephoneValidate"
            type="tel"
            @focusout.native="validateThelephone"
          />
          <hr class="payment__divider__shopify" />
        </div>

        <div
          v-if="showPix(paymentTypes)"
          :key="paymentTypes.title"
          class="payment__pix"
        >
          <AmInput
            v-model="payment.document"
            v-mask="'###.###.###-##'"
            :test-name="'cpf'"
            class="input--custom mt-2"
            :label="$t('steps.payment.pix.cpf')"
            placeholder="___.___.___-__"
            :validity-state="statusCPFValidate"
            :secondary-label="textCPFValidate"
            type="tel"
            @input="validateCPF"
          />

          <AmInput
            v-model="creditCard.email"
            :test-name="'email'"
            class="input--custom"
            :label="$t('steps.data.email.label', { textOptional: '' })"
            type="email"
            :placeholder="$t('steps.data.email.placeholder')"
            :validity-state="statusEmailValidate"
            :secondary-label="textEmailValidate"
            @focusout.native="validateEmail"
          />

          <AmInputMask
            v-model="creditCard.telephone"
            typeMask="fixed"
            :mask="['(##) #####-####', '(##) ####-####']"
            data-test="telephone"
            class="input--custom input-telephone"
            :label="$t('steps.data.telephone_shopify.label')"
            :placeholder="$t('steps.data.telephone.placeholder')"
            :validity-state="statusTelephoneValidate"
            :secondary-label="textTelephoneValidate"
            type="tel"
            @focusout.native="validateThelephone"
          />
        </div>
      </template>
    </AmList>
  </div>
</template>

<script>
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import AmCreditCard from '@/components/molecules/shopify/AmCreditCard.vue'
import validateCPFMixin from '@/components/mixins/validateCPFMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
import AmList from '@/components/molecules/shopify/AmList.vue'
import AmListItem from '@/components/atoms/AmListItem.vue'
import themeMixin from '@/components/mixins/themeMixin'
import BilletMessage from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/BilletMessage/BilletMessage.vue'
import AmPhoneNumber from '@/components/molecules/AmPhoneNumber.vue'

export default {
  name: 'PaymentShopify',
  components: {
    AmCreditCard,
    VueRecaptcha,
    AmList,
    AmListItem,
    BilletMessage,
    AmPhoneNumber,
  },
  mixins: [validateCPFMixin, currencyFilterMixin, themeMixin, replaceSpecialCharactersMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: null,
          credit_card_number: null,
          document: null,
          credit_card_year: null,
          credit_card_month: null,
          credit_card_cvv: null,
          installments: null,
          recaptcha_response: null,
          recaptcha_attempts: 0,
          couponCodeModel: '',
        }
      },
    },
  },
  data() {
    return {
      creditCard: {
        number: null,
        shelfLife: null,
        cvv: null,
        telephone: null,
        email: null,
        internationalPhoneNumber: null,
      },
      documentInternational: ['AR', 'UY'],
      statusNameValidate: null,
      textNameValidate: '',
      recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY.replace(/"/g, ''),
      recaptchaEnabled: process.env.VUE_APP_RECAPTCHA_ENABLED.replace(/"/g, ''),
      recaptchaMarked: false,
      recaptchaMaxAttempts: process.env.VUE_APP_RECAPTCHA_MAX_ATTEMPTS.replace(/"/g, ''),
      recaptchaErrorShow: false,
      saveData: true,
      paymentTypeSelected: null,
      statusCouponValidate: null,
      textCouponValidate: null,
      couponApplied: false,
      statusTelephoneValidate: null,
      statusInternationalTelephoneError: false,
      textTelephoneValidate: '',
      statusEmailValidate: null,
      textEmailValidate: '',
      payments: [
        {
          title: this.$t('steps.payment.type.card'),
          option: {
            value: 'card',
          },
        },
        {
          title: this.$t('steps.payment.type.billet'),
          option: {
            value: 'billet',
          },
        },
        {
          title: this.$t('steps.payment.type.pix'),
          option: {
            value: 'pix',
          },
        },
      ],
    }
  },
  computed: {
    ...mapState('Checkout', {
      cart: (state) => state.cart,
      coupon_code: (state) => state.cart.coupon,
      payment_type: (state) => state.payment_type,
      settings: (state) => {
        return state.cart.settings
      },
    }),
    ...mapGetters('Card', ['selectedCardType', 'cardType']),
    ...mapGetters('Cart', ['getIsInternational']),
    isCreditCard() {
      return (
        !this.getIsInternational ||
        this.cardType === 'credito' ||
        (this.cardType === 'multiplo' && this.selectedCardType === 'credito')
      )
    },
    cardFlags() {
      return this.cart.is_international
        ? ['visa', 'master-card', 'american-express', 'carnet']
        : ['visa', 'master-card', 'hiper-card', 'american-express', 'diners-club', 'elo']
    },
    payment: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    installments() {
      return this.cart.installments.map((installments) => {
        return {
          id: installments.installment,
          label: `${installments.installment}x de ${this.formatIntallmentsCurrency(
            this.cart.is_international ? installments.value_converted : installments.value
          )}`,
        }
      })
    },
  },
  watch: {
    paymentTypeSelected: {
      immediate: true,
      deep: true,
      handler() {
        this.resetValidate()
        this.$emit('paymentSelected', this.paymentTypeSelected)
      },
    },
    creditCard: {
      deep: true,
      handler() {
        let creditCardYearAndMonth = []

        if (this.creditCard.shelfLife && this.creditCard.shelfLife.length === 5) {
          creditCardYearAndMonth = this.creditCard.shelfLife.split('/')
        }

        const [month = null, year = null] = creditCardYearAndMonth

        const paymentCreditCardValue = {
          ...this.payment,
          credit_card_number: this.creditCard.number,
          credit_card_year: year,
          credit_card_month: month,
          credit_card_cvv: this.creditCard.cvv,
          telephone: this.cart.is_international
            ? this.creditCard.internationalPhoneNumber
            : this.creditCard.telephone,
          email: this.creditCard.email,
        }

        this.payment = paymentCreditCardValue
      },
    },
    settings: {
      immediate: true,
      deep: true,
      handler() {
        if (this.settings) {
          this.formatPaymentsOptions()
        }
      },
    },
    cart: {
      deep: true,
      handler(newCart) {
        if (newCart.is_international) {
          this.paymentTypeSelected = 'card'
        }
      },
    },
  },
  mounted() {
    if (this.cart.is_international) this.paymentTypeSelected = 'card'
  },
  methods: {
    ...mapMutations('Checkout', ['SET_PAYMENT_TYPE']),
    ...mapMutations('Card', ['SET_SELECTED_TYPE']),
    setSelectedCardType(value) {
      this.SET_SELECTED_TYPE(value)
    },
    formatIntallmentsCurrency(value) {
      return this.cart.is_international
        ? this.$options.filters.currency(value, { codeCurrency: this.cart.currency_code })
        : this.$options.filters.currencyBRL(value)
    },
    resetValidate() {
      this.statusTelephoneValidate = null
      this.statusCPFValidate = null
      this.textTelephoneValidate = ''
      this.textCPFValidate = ''
    },
    showCard(paymentType) {
      if (!paymentType) {
        return false
      }

      return paymentType.option.value === 'card' && this.paymentTypeSelected === 'card'
    },
    showBillet(paymentType) {
      if (!paymentType) {
        return false
      }

      return paymentType.option.value === 'billet' && this.paymentTypeSelected === 'billet'
    },
    showPix(paymentType) {
      if (!paymentType) {
        return false
      }

      return paymentType.option.value === 'pix' && this.paymentTypeSelected === 'pix'
    },
    formatPaymentsOptions() {
      this.payments = this.settings.payments.map((payment) => {
        return {
          title: this.$t(`steps.payment.type.${payment}`),
          option: {
            value: payment,
          },
        }
      })
    },
    validateData() {
      try {
        if (this.paymentTypeSelected !== 'card') {
          this.validateCPF()
          this.validateThelephone()
          this.validateEmail()
          return true
        }

        if (!this.cart.is_international) {
          this.validateThelephone()
          this.validateCPF()
        } else {
          this.validateInternacionalPhone()
        }

        this.validateEmail()
        this.validateName()
        this.$refs.creditCard[0].validateCreditCard()
        this.validateRecaptcha()

        return true
      } catch (_) {
        return false
      }
    },
    validateEmail() {
      if (!this.creditCard.email) {
        this.statusEmailValidate = 'error'
        this.textEmailValidate = this.$t('steps.validators.required')
        throw new Error(false)
      }

      const emailRule = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/g
      const validEmail = emailRule.test(this.creditCard.email)
      if (this.creditCard.email) {
        if (!validEmail) {
          this.statusEmailValidate = 'error'
          this.textEmailValidate = this.$t('steps.validators.invalid.email')
          throw new Error(false)
        }
      }

      this.statusEmailValidate = 'success'
      this.textEmailValidate = ''

      return true
    },
    validateThelephone() {
      if (!this.creditCard.telephone) {
        this.statusTelephoneValidate = 'error'
        this.textTelephoneValidate = this.$t('steps.validators.required')
        throw new Error(false)
      }

      const replacePhone = this.replaceSpecialCharacters(this.creditCard.telephone)
      if (replacePhone.length < 10) {
        this.statusTelephoneValidate = 'error'
        this.textTelephoneValidate = this.$t('steps.validators.invalid.phone')
        throw new Error(false)
      }

      this.statusTelephoneValidate = 'success'
      this.textTelephoneValidate = ''

      return true
    },
    handleInternacionalPhoneInput(payload) {
      const internationalNumber = payload?.formattedNumber ?? payload.phoneNumber ?? ''
      this.creditCard.internationalPhoneNumber = internationalNumber.startsWith('+')
        ? internationalNumber.slice(1)
        : internationalNumber
      this.statusInternationalTelephoneError = !payload.isValid
      this.validateInternacionalPhone()
    },
    validateInternacionalPhone() {
      if (!this.creditCard.internationalPhoneNumber) {
        this.textTelephoneValidate = this.$t('steps.validators.required')
        this.statusInternationalTelephoneError ||= true
        return false
      }
      if (this.statusInternationalTelephoneError) {
        this.textTelephoneValidate = this.$t('steps.validators.invalid.phone')
        return false
      }
      this.textTelephoneValidate = ''
      return true
    },
    validateName() {
      if (!this.payment.name) {
        this.statusNameValidate = 'error'
        this.textNameValidate = this.$t('steps.validators.required')
        throw new Error(false)
      }

      if (this.payment.name.split(' ').length === 1) {
        this.payment.name += ' - '
      }

      this.statusNameValidate = 'success'
      this.textNameValidate = ''

      return true
    },
    verifyRecaptcha(recaptchaToken) {
      this.recaptchaMarked = true
      this.payment.recaptcha_response = recaptchaToken
      this.$emit('recaptchaToken', recaptchaToken)
    },
    expiredRecaptcha() {
      this.recaptchaMarked = false
      this.$refs.recaptcha.reset()
    },
    validateRecaptcha() {
      if (!this.showRecaptcha()) {
        this.recaptchaErrorShow = false
        return true
      }

      if (!this.recaptchaMarked) {
        this.recaptchaErrorShow = true
        this.$el.querySelector('.recaptcha-show div').classList.add('recaptcha-iframe-error')
        throw new Error('teste')
      }

      this.recaptchaErrorShow = false
      return true
    },
    showRecaptcha() {
      if (!this.recaptchaEnabled) {
        return false
      }

      return (
        this.recaptchaMaxAttempts === 0 ||
        this.payment.recaptcha_attempts >= this.recaptchaMaxAttempts
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.input-telephone {
  ::v-deep {
    .additional-slot {
      span {
        display: none;
      }
    }
  }
}

.input-container {
  .select-installments {
    padding-left: 8px;
    padding-right: 28px;
    height: 42px;
    color: #333333;
    border: 1px solid #d2d6de;
    width: 100%;
    font-size: 14px;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 5px;
    grid-template-areas: 'select';
    align-items: center;
    display: grid;
    position: relative;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
  }
  span {
    position: absolute;
    bottom: 8px;
    right: 5px;
    pointer-events: none;
  }
}
.recaptcha {
  justify-content: center;
  margin-top: 25px;
}
.recaptcha-error {
  color: #dd4b39 !important;
  margin-left: 29%;
  font-size: 12px;
}
.recaptcha-show {
  justify-content: center;
  display: flex;
}
.recaptcha-iframe-error {
  border: 1px solid #dd4b3b;
  border-radius: 2px;
}

// card

.payment {
  &__coupon {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .input--custom {
      width: 100%;
      margin: 0;
    }

    .input--coupon-applied {
      ::v-deep {
        .input-container {
          input {
            opacity: 1;
            background: rgba($blue, 0.2);
            border-color: rgba($blue, 0.8);
            color: rgba($blue, 0.8);
            font-weight: 500;
          }
        }
      }
    }

    &__applyer {
      margin: 0 0 0 7px;
    }

    &__remove {
      cursor: pointer;
    }
  }

  &__save_data {
    margin: 25px 0 22px 0;
  }

  &__flags {
    margin: 0 8px 0 0;
  }

  &__divider__shopify {
    margin: 0;
    margin-top: 20px;
  }

  &__divider {
    margin: 0;
  }

  &__divider:last-child {
    display: none;
  }

  .label--custtom {
    width: 100%;
  }

  &__boleto {
    margin: 0 20px;
  }

  &__pix {
    margin: 0 20px;
  }
}
</style>
